<template>
  <div class="modal_wrapper" :style="{backgroundColor: backgroundColor}">
    <div class="container">
      <div class="modal_container">
        <div class="modal_header">
          <img :src="info" height="25px" />
          {{ title }}
        </div>
        <div class="modal_body">
          <div class="body">
            <inputSection
              :titleLabel="modalTitle"
              @inputUpdate="inputUpdateDefineInfo('importantMsgTitle')"
            ></inputSection>
            <textAreaSection
              :titleLabel="modalValue"
              @inputUpdate="inputUpdateDefineInfo('importantMsgValue')"
            ></textAreaSection>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="cancelButton"
              class="cancel_button"
              @click="$emit('close')"
            />
            <input
              type="button"
              :value="okButton"
              class="finish_button"
              @click="showConfirmModal = true"
            />
          </div>
        </div>
        <div class="modal_window" v-if="showConfirmModal">
          <confirmModalWindow
            :question="confirmWord"
            @close="stayClose"
            @ok="updateImportantInfo"
          >
          </confirmModalWindow>
        </div>
        <div class="complete_modal_window" v-if="showCompleteModal">
          <finishModalWindow :question="completeWord" @close="close">
          </finishModalWindow>
        </div>
        <div class="modal_window" v-if="showFailureModal">
          <finishModalWindow :question="failureWord" @close="stayClose">
          </finishModalWindow>
        </div>
        <div class="loading_modal_window" v-if="showloadingModal">
          <loadingModalWindow @close="close"> </loadingModalWindow>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import inputSection from './modalwindowComponents/inputSection.vue'
import textAreaSection from './modalwindowComponents/textAreaSection.vue'
import confirmModalWindow from './confirmModalWindow.vue'
import finishModalWindow from './finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      info: require('../../../../img/info.png'),
      title: '重要なお知らせ情報更新',
      modalTitle: '重要なお知らせタイトル:',
      modalValue: '重要なお知らせ内容:',
      cancelButton: 'キャンセル',
      okButton: '更新',
      completeWord: '',
      failureWord: '',
      confirmWord: '重要なお知らせ情報を更新しますか？',
      showConfirmModal: false,
      showCompleteModal: false,
      showFailureModal: false,
      showloadingModal: false
    }
  },
  computed: {
    backgroundColor() {
      if (
        this.showCompleteModal === true ||
        this.showConfirmModal === true ||
        this.showFailureModal === true
      ) {
        return ''
      } else {
        return 'rgba(0, 0, 0, .5)'
      }
    },
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    importantMsgTitle() {
      return this.$store.state.corporationsCommonOption.importantMsgTitle
    },
    importantMsgValue() {
      return this.$store.state.corporationsCommonOption.importantMsgValue
    }
  },
  components: {
    inputSection,
    textAreaSection,
    confirmModalWindow,
    finishModalWindow,
    loadingModalWindow
  },
  created() {
    this.$store.dispatch('corporationsCommonOption/cleareDefineInfo')
  },
  methods: {
    close(e) {
      this.$emit('close')
    },
    stayClose(e) {
      this.showFailureModal = false
      this.showConfirmModal = false
    },
    inputUpdateDefineInfo(e) {
      this.$store.dispatch('corporationsCommonOption/inputUpdateDefineInfo', {
        name: e,
        value: event.target.value
      })
    },
    async updateImportantInfo() {
      this.showloadingModal = true
      this.showConfirmModal = false
      if (this.importantMsgTitle === null || this.importantMsgTitle === '') {
        let eventNumber =
          this.$store.state.error.sysErrorCode.sysErrorCode_580001
        this.failureWord =
          this.sysErrorMsg.MSGCRD0057.name +
          this.sysErrorMsg.MSGCRD0057.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      if (this.importantMsgValue === null || this.importantMsgValue === '') {
        let eventNumber =
          this.$store.state.error.sysErrorCode.sysErrorCode_580001
        this.failureWord =
          this.sysErrorMsg.MSGCRD0058.name +
          this.sysErrorMsg.MSGCRD0058.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      try {
        await this.$store.dispatch('corporationsCommonOption/updateDefineInfo')
        this.completeWord = '変更しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber =
          this.$store.state.error.sysErrorCode.sysErrorCode_580001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0061')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    }
  }
}
</script>
<style scoped>
.container {
  display: table-cell;
  vertical-align: middle;
}
.body {
  width: 100%;
  height: 391px;
  padding-top: 40px;
}
.modal_container {
  height: 485px;
}
.modal_header {
  background-color: #33ccff;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/modalWindow/importantMsgModalWindow.vue